const marked = require('./marked.min.js')

marked.setOptions({
  breaks: true,
})

const md = ([string]) => marked(string.replace(/^\n|\n$|/g, ''))

const meta = {
  title: 'strawberry.pink',
  description: 'a cool website.',
  thumbnail: 'https://strawberry.pink/thumb.png',
  themeColor: '#EB7A96',
  url: 'https://strawberry.pink'
}

const comics = [
  {
    name: 'strawberry',
    issues: [
      {
        title: 'strawberry pink',
        location: 'assets/comics/strawberry/000',
        slides: [
          {
            url: '00banner white.webp',
            metadata: 'a banner/splash page.', // aria-label
            note: md`
*welcome to Strawberry Pink, a comic about a Deaf bunny who wants to be a pop star.*
` // indentation will show
          },
          {
            url: '01.webp',
            metadata: 'first page',
            note: md`**Meet Marie, a rabbit! Be sure to click the "next >" instead of the "last" to go through the pages.**`
          },
          {
            url: '02.webp',
            metadata: 'second page',
            note: md`**Meet Marie, part 2**`
          },
          {
            url: '03.webp',
            metadata: 'third page',
            note: md`**Meet Marie, Part 3**`
          },
          {
            url: '04.webp',
            metadata: 'fourth page',
            note: md`**Meet Marie, Part 4! Hearing aids and cochlear implants are actually pretty common! About 2 to 3 out of every 1,000 children in the United States are born with a detectable level of hearing loss in one or both ears. [Source](https://www.nidcd.nih.gov/health/statistics/quick-statistics-hearing)**`
          },
          {
            url: '05.webp',
            metadata: 'fifth page',
            note: md`**there's a lot of different ranges in hearing, from mild to moderate to severe to profound! I'm in the S-P range (Guess why the comic is called Strawberry Pink lol)**`
          },
          {
            url: '06.webp',
            metadata: 'sixth page',
            note: md`**Sorry for the drafts, I didn't finish in time.**`
          },
          {
            url: '07.webp',
            metadata: 'seventh page',
            note: md`**Back to normal.**`
          },
          {
            url: '08.webp',
            metadata: 'eighth page',
            note: md`**Marie just suddenly goes bald. Pls ignore that...**`
          },
          {
            url: '09.webp',
            metadata: 'ninth page',
            note: md`**I remember having to let go. Sorry for the drafts, I didn't finish in time.**`
          },
          {
            url: '10.webp',
            metadata: 'tenth page',
            note: md`**New beginnings are hard. Sorry for the drafts, I didn't finish in time.**`
          },
          {
            url: '11.webp',
            metadata: 'eleventh page',
            note: md`**Marie's actually taking a hearing test- the audiologist plays the different frequencies and then s/he checks whether you can hear them, which creates an [audiogram](https://www.hear-it.org/Audiogram-), which is a chart of what you can hear! Sorry for the drafts, I didn't finish in time.**`
          },
          {
            url: '12.webp',
            metadata: 'twelfth page',
            note: md`**Marie's actually taking a hearing test- you play the different frequencies and the audiologist checks whether you can hear them, which creates an audiogram: Here is how to read and understand [one](https://www.hear-it.org/Audiogram-)! Sorry for the drafts.**`
          },
          {
            url: '13.webp',
            metadata: 'thirteenth page',
            note: md`**A new era?**`
          },
          {
            url: '14.webp',
            metadata: 'fourteenth page',
            note: md`**My hands hurt.**`
          },
          {
            url: '15.webp',
            metadata: 'fifteenth page',
            note: md`**New friends? Maybe?.**`
          },
          {
            url: '16.webp',
            metadata: 'sixteenth page',
            note: md``
          },
        ]
      }, 
    ]
  },

  // if the config gets too big, you can require() modules for each comic (or even issue if necessary)
  /*
    // strawberry2.js
    module.exports = {
      name: 'strawberry2',
      issues: [...]
    }
    ...
    // config.js
    const comics = [
      require('./strawberry2.js')
    ]
  */
]

const about = md`
**"It's strange when people have to think about something being wrong or different." -Aurora Asknes**

**About me, and a commentary on Strawberry Pink:**
I'm **moss**, the writer of this comic. I'm trying to teach more people about myself and about the Deaf community because I'm stuck inside my house and there's a highly contagious virus outside (as of March/mid-May). The main goal of Strawberry Pink (S-P) is to educate others about my personal experiences as a Deaf and autistic individual. S-P tries to raise awareness and understanding and promote acceptance about the topics in my life that are closest and most dear to me, which range anywhere from autism acceptance to accessibility to cats.

This comic is semi-autobiographical. There are many elements in my life that I incorporate into these pages, and also others that aren’t necessarily part of my life but seem to be a common trend in the lives of other Deaf and Hard of Hearing individuals. I want to teach people about ASL, Deaf culture, and share other stories about hearing and make sure that these voices aren't left unheard. (or rather, unseen.)

Strawberry Pink is a comic that features different kinds of hearing (ranging from regular people to people who can't hear at all), as well as the different kinds of communication utilized by Deaf people. There's quite a bit of irony in this comic, so see if you can catch it all.

Deafness is a medical condition caused by hearing loss. Despite all of this, Deaf people have created a vibrant community that supports and sees deafness as an enriching aspect in their lives as part of the community. Does this mean that deafness is cultural or pathological? If it is cultural, then should it be considered a disability? 

**Why 'D'-Deaf and not 'd'-deaf?**
The reason why Deaf individuals capitalize the 'D' in Deaf is to show that they are part of the Deaf community. It means that they embrace the ideas, values, and culture of the Deaf community.(0) The term "Deaf" should be capitalized when talking about a member of the Deaf community, or if you yourself are deaf and in the Deaf community, you may use it. For example, I'm deaf, and I'm also Deaf; I prefer to use Deaf, however because it is part of me as a disability and also part of my cultural identity. Using lowercase 'deaf' means that the person cannot hear, and may not be in the Deaf community.

In the medical perspective, the focus is about correcting hearing loss. It emphasizes making the deaf individual appear as if they were hearing, or as "normal as possible". The pathological perspective is that deafness is abnormal;  hearing people are the norm. Correction often comes in the form of wearing hearing aids, cochlear implant surgery, and learning how to lipread and speak. Some people who take on the pathological perspective (such as doctors and speech therapists) may think that a deaf person has mental and learning disabilities. However this isn't true at all; lack of access to language (be it in the form of sign or oral) actually is one of the main reasons why many deaf people struggle to communicate.

Taking on a cultural perspective of Deafness means that Deafness is embraced as a unique difference and doesn't focus on the pathological/medical standpoint that deafness is something that needs to be fixed. Sign language in the Deaf community is encouraged and celebrated. Deafness is something that the Deaf community is proud of. That is why the term "Deaf pride" exists.

**What is CI?** (2)
A cochlear implant gives a typically deaf person (who often has severe-to-profound hearing loss, though some in the moderate range have been implanted with CI) the ability to percieve sound. The implant has of an external part, the speech processor, that sits on the ear and a weak magnetic coil that is put under the skin near the ear on the head. 
[image of a cochlear implant](https://www.nidcd.nih.gov/sites/default/files/Documents/health/hearing/images/cochlear-implant-web-pic.jpg "image of a cochlear implant")

The invention of cochlear implants (CI) is controversial because of the fact that it is touted as a "cure" for deafness, and is presented as a way to be "normal" in a society that simultaneously celebrates and looks down upon differences. CI is celebrated in the scientific community as a way for people who cannot hear to actually perceive sounds (never mind the fact that the sounds making sense to the person is actually more important than being able to hear in the first place). However, a large majority of CI users (myself included) report difficulty following group conversations, talking on the phone, or hearing in loud and/or busy environments with a lot of background noise.

Some CI users are fairly successful using a CI and are able to integrate themselves into the hearing world without much trouble (the person might speak, use only their CI); others are not (to that end, the person might be able to speak, but will prefer to use ASL or alternative means of communication). The invention of CI blurs the line between "hearing" and "deaf" which potentially changes the model of a typical Deaf person who participates within the Deaf community. Historically the Deaf community has been oppressed and forced into schools that promoted oralism instead of sign language, taught them to lipread, and made them conform to hearing expectations. Oralism is sometimes considered as the Deaf community’s greatest adversary because it defines language as speech.

“Language is human; speech is language; therefore deaf people are inhuman and deafness is a problem.” (Brenda Bruggemann) [(1)](https://www.britannica.com/topic/audism#ref1186214)

**What is oralism?**
Oralism supports the idea that deaf people should adapt to the hearing world as deafness is considered a disability (as oralism supports the pathological perspective that deafness is abnormal), and CI furthers that in a sense because it makes a deaf person's hearing "normal". The concept of oralism is an ableist one (the word for deaf ableism is audism, which is the ableist idea that being able to hear makes you better than people who cannot hear.) The desire to normalize deaf people into hearing people is seen as audist and discriminatory and oppressive at the hands of a hearing majority.(1)
We live in a "golden age" where Deafness is accepted! So cochlear implants raise legitimate concerns in the Deaf community about the reversal of the acceptance of deafness, as well as the fact that some audists are a very big proponent of CI.

The Deaf community celebrates deafness as something that enriches their lives. Once a deaf or hard of hearing child is born, the child is immediately welcomed into the Deaf community as part of their family. CI creates a lot of fear around the fact that their community may die out because many children who use CI are mainstreamed and often not taught ASL. However, ultimately the Deaf community should not force the child to keep the community alive as it is the child's choice whether they want to be in the community or not.

If you've read this far down, nice. Did you know S-P also stands for severe-to-profound? Watch out for some of the irony in the comic. Site credit goes to [Apple](https://poisonapple.dev/), who helped me with the majority of this site.
Thank you so much!

Sources:
[0: D-deaf, Lifeprint](https://www.lifeprint.com/asl101/pages-layout/terminology.htm)
[1: Audism, Britannica](https://www.britannica.com/topic/audism#ref1186214)
[2: What is CI? NIDCD](https://www.nidcd.nih.gov/health/cochlear-implants#a)
`

const contact = md`
contact stuff
[linkedin](https://www.linkedin.com/in/aerori/),  [email me](mailto:amcheng12@gmail.com)
`

module.exports = {
  meta, 
  comics,
  about,
  contact,
}
